import { Component, OnInit } from '@angular/core';
import { TcPage, IPageState } from '@tc/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-estimation-lines-page',
  templateUrl: './estimation-lines-page.component.html',
  styleUrls: ['./estimation-lines-page.component.scss']
})
export class EstimationLinesPageComponent extends TcPage implements OnInit {

  constructor(
    store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'estimation-lines-page.title'
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }
}
